import React, { useState } from 'react'
import { Drawer, Dropdown, Menu, Tabs } from 'antd'
import { Route, Switch, useHistory, Link, useParams } from 'react-router-dom'
import Receive from "../../components/reusable/receive";
import { AiOutlineDown } from 'react-icons/ai'

import { useToggle, stringifyDate, usePet, normalize } from '../../modules'

const { TabPane } = Tabs

const ContactGroup = ({ path, onClose }) => {

    const [params, setParams] = useState({})

    const history = useHistory()
    const { id } = useParams()

    const [visible, toggleVisible] = useToggle(true)
    
    const [{loading: cLoading, error: cError, data : oneContactGroup}] = usePet('oneContactGroup', { id }, {notify: true})

    const close = () => {
        toggleVisible()
        // onClose()
        setTimeout(() => history.goBack(), 300)
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            width="40%">
            {/* <p className="font-extrabold text-3xl mb-0">Message #{messages?.id}</p> */}
            <p className="font-extrabold text-3xl mb-0">Group # {id}</p>
            <Tabs className="mt-0">
                <TabPane key="0" tab="View Group">
                    <div className="flex flex-col pr-3 py-3">
                        <p className="font-semibold text-lg mb-2">Group Name:</p>
                        <p>{oneContactGroup?.name}</p>
                        <p className="font-semibold text-lg mb-2">Department:</p>
                        <p>{oneContactGroup?.department}</p>
                        <p className="font-semibold text-lg mb-2">No of Contacts:</p>
                        <p>{oneContactGroup?.members.length}</p>
                    </div>
                    {/* add a table here to showw contacts */}
                </TabPane>
                <TabPane key="1" tab="Members">
                    <table className="table-auto w-full">
                        {/* Table header */}
                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                            <tr>
                                <th className="p-2">
                                    <div className="font-semibold text-left">No</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Name</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Contact</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Email</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                        <Receive error={null} loading={false} progress>
                            {
                                oneContactGroup?.members.map((member, key) =>
                                    <tr>
                                        <td className="p-2">
                                            <div className="text-left">{key + 1}</div>
                                        </td>
                                        <td className="p-2">
                                            <div className="text-left">{member?.name}</div>
                                        </td>
                                        <td className="p-2">
                                            <div className="text-left">{member?.phone}</div>
                                        </td>
                                        <td>
                                            <div className="text-left">{member?.email}</div>
                                        </td>
                                    </tr>
                                )
                            }
                        </Receive>
                        </tbody>
                    </table>
                </TabPane>
            </Tabs>
        </Drawer>
    )
}

export default ContactGroup